<template>
  <div>
    <Product></Product>
  </div>
</template>

<script>
import Product from './Product'

export default {
  name: 'app',
  components: {
    Product
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue